const authTypes = {
  LOGIN_USER: "LOGIN_USER",
  LOGIN_USER_SUCCESS: "LOGIN_USER_SUCCESS",
  LOGIN_USER_ERROR: "LOGIN_USER_ERROR",
  GET_PROFILE: "GET_PROFILE",
  UPDATE_LEVEL: "UPDATE_LEVEL",
  CLEAR_STATE: "CLEAR_STATE",
  RECRUITURMENT_LIST: "RECRUITURMENT_LIST",
  RECRUITURMENT_LIST_SUCCESS: "RECRUITURMENT_LIST_SUCCESS",
  RECRUITURMENT_LIST_RESET: "RECRUITURMENT_LIST_RESET",
  ADD_RECRUITURMENT: "ADD_RECRUITURMENT",
  ADD_RECRUITURMENT_SUCCESS: "ADD_RECRUITURMENT_SUCCESS",
  CANDIDATE_LIST: "CANDIDATE_LIST",
  CANDIDATE_LIST_SUCCESS: "CANDIDATE_LIST_SUCCESS",
  CANDIDATE_LIST_RESET: "CANDIDATE_LIST_RESET",
  ADD_CANDIDATE: "ADD_CANDIDATE",
  ADD_CANDIDATE_SUCCESS: "ADD_CANDIDATE_SUCCESS",
  DELETE_RECRUTER: "DELETE_RECRUTER",
  DELETE_RECRUTER_SUCCESS: "DELETE_RECRUITER_SUCCESS",
  DELETE_CANDIDATE: "DELETE_CANDIDATE",
  DELETE_CANDIDATE_SUCCESS: "DELETE_CANDIDATE_SUCCESS",
  EDIT_RECRUITER: "EDIT_RECRUITER",
  EDIT_RECRUITER_SUCCESS: "EDIT_RECRUITER_SUCCESS",
  EDIT_CANDIDATE: "EDIT_CANDIDATE",
  EDIT_CANDIDATE_SUCCESS: "EDIT_CANDIDATE_SUCCESS",
  SET_CODING_THEME: "SET_CODING_THEME",
  SET_CODING_LANG: "SET_CODING_LANG",
  RESUME_UPLOAD: "RESUME_UPLOAD",
  DELETE_RESUME: "DELETE_RESUME",
  RESUME_UPLOAD_REQUESTED: "RESUME_UPLOAD_REQUESTED",
  RESUME_UPLOAD_FAILURE: "RESUME_UPLOAD_FAILURE",
  DELETE_RESUME_REQUESTED: "DELETE_RESUME_REQUESTED",
  DELETE_RESUME_SUCCESS: "DELETE_RESUME_SUCCESS",
  TEST_COMPLETED: "TEST_COMPLETED",
  TEST_COMPLETED_SUCCESS: "TEST_COMPLETED_SUCCESS",
  CANDIDATE_DETAILS: "CANDIDATE_DETAILS",
  CANDIDATE_DETAILS_SUCCESS: "CANDIDATE_DETAILS_SUCCESS",
  CANDIDATE_PROFILE: "CANDIDATE_PROFILE",
  CANDIDATE_PROFILE_SUCCESS: "CANDIDATE_PrOFILE_SUCCESS",
  RECRUITER_DETAILS: "RECRUITER_DETAILS",
  RECRUITER_DETAILS_SUCCESS: "RECRUITER_DETAILS_SUCCESS",
  GOT_PROFILE: "GOT_PROFILE",
  USER_EXISTS: "USER_EXISTS",
  ACTIVATE_CANDIDATE: "ACTIVATE_CANDIDATE",
  ACTIVATE_CANDIDATE_SUCCESS: "ACTIVATE_CANDIDATE_SUCCESS",
  ACTIVATE_RECRUITER: "ACTIVATE_RECRUITER",
  ACTIVATE_RECRUITER_SUCCESS: "ACTIVATE_RECRUITER_SUCCESS",
  RECRUITER_FILTER: "RECRUITER_FILTER",
  RECRUITER_FILTER_SUCCESS: "RECRUITER_FILTER_SUCCESS",
  RECRUITER_LIST_TOTAL: "RECRUITER_LIST_TOTAL",
  RECRUITER_DASHBOARD: "RECRUITER_DASHBOARD",
  RECRUITER_DASHBOARD_SUCCESS: "RECRUITER_DASHBOARD_SUCCESS",
  CANDIDATE_FILTER: "CANDIDATE_FILTER",
  CANDIDATE_FILTER_SUCCESS: "CANDIDATE_FILTER_SUCCESS",
  CANDIDATE_UPLOAD_RESUME: "CANDIDATE_UPLOAD_RESUME",
  CANDIDATE_TOTAL_COUNT: "CANDIDATE_TOTAL_COUNT",
  CANDIDATE_MY_COUNT: "CANDIDATE_MY_COUNT",
  CANDIDATE_ALL_COUNT: "CANDIDATE_ALL_COUNT",
  CANDIDATE_UPLOAD_RESUME_SUCCESS: "CANDIDATE_UPLOAD_RESUME_SUCCESS",
  CANDIDATE_REPORT: "CANDIDATE_REPORT",
  CANDIDATE_REPORT_SUCCESS: "CANDIDATE_REPORT_SUCCESS",
  CANDIDATE_SEARCH_BY_EMAIL: "CANDIDATE_SEARCH_BY_EMAIL",
  CANDIDATE_SEARCH_BY_EMAIL_SUCCESS: "CANDIDATE_SEARCH_BY_EMAIL_SUCCESS",
  REMOVE_RESUME: "REMOVE_RESUME",
  REMOVE_RESUME_SUCCESS: "REMOVE_RESUME_SUCCESS",
  DOWNLOAD_RESUME: "DOWNLOAD_RESUME",
  DOWNLOAD_RESUME_SUCCESS: "DOWNLOAD_RESUME_SUCCESS",
  UPLOAD_PROFILE: "UPLOAD_PROFILE",
  UPLOAD_PROFILE_SUCCESS: "UPLOAD_PROFILE_SUCCESS",
  CANDIDATE_DP: "CANDIDATE_DP",
  CANDIDATE_DPURL_SUCCESS: "CANDIDATE_DPURL_SUCCESS",
  CANDIDATE_DPURL_RESET: "CANDIDATE_DPURL_RESET",
  GET_AOSI: "GET_AOSI",
  GET_AOSI_SUCCESS: "GET_AOSI_SUCCESS",
  CANDIDATE_FETCH_RESUME_DETAILS: "CANDIDATE_FETCH_RESUME_DETAILS",
  CANDIDATE_FETCH_RESUME_DETAILS_SUCCESS: "CANDIDATE_FETCH_RESUME_DETAILS_SUCCESS",
  CANDIDATE_RESUME_SCAN_DETAILS: "CANDIDATE_RESUME_SCAN_DETAILS",
  CANDIDATE_RESUME_SCAN_DETAILS_SUCCESS: "CANDIDATE_RESUME_SCAN_DETAILS_SUCCESS",

  API_ERROR: "API_ERROR",
};

export default authTypes;
